import React from 'react';
import './style.css';
import OnboardButton from '../../base/onboard-button-component/OnboardButton';
import {useNavigate} from 'react-router-dom';
import {useSetRecoilState} from 'recoil';
import {informationAtom} from '../../../store/InformationStore';

const Popup = (props) => {

    const navigate = useNavigate();
    const setInformation = useSetRecoilState(informationAtom);
    const {visible, setVisible, rightPanelLang = 'tr'} = props;

    return <>
        {
            visible && (
                <>
                    <div className="onboard-popup-opacity"></div>
                    <div className="onboard-popup-root">
                        <div className="onboard-popup-header">
                            <p>{rightPanelLang === 'tr' ? 'Simülasyonu Başlat' : 'Start Simulation'}</p>
                        </div>
                        <div className="onboard-popup-content">
                            <span>{rightPanelLang === 'tr' ? 'Simülasyon başlatmak istediğinizden emin misiniz?' : 'Are you sure you want to start the simulation?'}</span>
                            <div className="onboard-popup-select-bar">
                                <OnboardButton outlineBlack label={rightPanelLang === 'tr' ? 'İptal' : 'Cancel'} onClick={() => setVisible(false)}/>
                                <OnboardButton label={rightPanelLang === 'tr' ? 'Evet' : 'Yes'} onClick={() => {
                                    setVisible(false);
                                    setInformation(prev => ({
                                        ...prev,
                                        clickAddress: '',
                                        simulationNumber: 0,
                                        simulationStep: 1
                                    }));
                                    navigate('/simulation')
                                }}/>
                            </div>
                        </div>
                    </div>
                </>
            )
        }

    </>;
};

export default Popup;
